module.exports = __webpack_public_path__ + "img/instruction2.ec4ca7f6.png";